import { Flex, type FlexProps } from '@chakra-ui/react';
import { type FunctionComponent } from 'react';

export type InputContainerProps = FlexProps;

export const defaultInputContainerStyles: FlexProps = {
  mx: '6',
  py: '1',
  direction: 'column',
  alignItems: 'flex-start',
};

export const InputContainer: FunctionComponent<InputContainerProps> = ({ children, ...rest }) => (
  <Flex {...defaultInputContainerStyles} {...rest}>
    {children}
  </Flex>
);
